<template>
  <div class="w-full max-w-[1160px] min-w-[463px] h-100 overflow-auto pt-[36px] px-[32px] flex flex-col mx-auto">

    <!-- Header -->
    <div class="flex flex-col mb-[32px]">
      <div class="flex items-center gap-[8px] mb-[4px]">
        <IconArrowLeft class="cursor-pointer" @click="backBtnHandler" />
        <span class="text-[#212529] text-[20px] font-[500] leading-[120%]">{{ nosologyTitle|| 'Нозология' }}</span>
      </div>

      <div class="text-[#6C757D] text-[16px] font-[400] leading-[150%]">Нозологии</div>
    </div>
    <!-- End Header -->
    <!-- Content -->
    <VSkeleton v-if="isLoading" class="w-full h-[228px] rounded-[8px]"/>
    <div v-else-if="isError" class="flex-1 min-h-0 flex">
      <v-placeholder
        message="Что-то пошло не так"
        description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
        :icon="{ name: 'xl/mood-confuzed' }"
        :retry="{ label: 'Повторить запрос', handler: fetchNosology }"
        class="!min-h-[70vh] h-full w-full !p-[24px]"
      >
        <template #footer>
          <p class="text-14-reg-400">Позвонить в техподдержку</p>
          <a
            class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
            href="tel:88005000299"
            >8 800 500-02-99</a>
          </template>
        </v-placeholder>
      </div>

      <div v-else>
        <div v-if="isEditMode">
          <NosologyForm
            :nosology="nosology"
            editMode
            :diagnoses="diagnoses"
            :backBtnActive="backBtnActive"
            :is-infinite-loading="isInfiniteLoading"
            :is-emit-src-loading="isEmitSrcLoading"
            @updateNosology="updateNosologyHandler"
            @update:backBtnActive="updateBackBtnActive"
            @cancel="cancelHandler"
            @loadMoreMkb="loadMoreMkb"
            @getMkbFromSearch="getMkbFromSearch"
          />
        </div>
        <div v-else class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">Описание</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ nosology?.description || '-' }}</p>
          </div>
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">Диагнозы МКБ</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ nosology?.diagnoses.map((diagnosis) => diagnosis.mkbCode).join(', ') || '-' }}</p>
          </div>
          <div class="flex justify-start gap-x-[8px]">
            <VButton size="m" @click="isEditMode = true" label="Редактировать" />
          </div>
        </div>
      </div>
    <!-- End Content -->
  </div>
</template>

<script>
import nosologyService from '@/services/nosology/nosology.service';
import storiesService from '@/services/';
import IconArrowLeft from '@/assets/images/icon-left.svg';
import {VSkeleton, VPlaceholder, VButton} from '@gostelemed.front/rt-doctis.designsystem';
import NosologyForm from '@/components/Kzs/Nosology/NosologyForm';
import mkbMixin from '@/mixins/mkb.mixin';

export default {
  name: 'NosologyView',
  components: {
    IconArrowLeft,
    VSkeleton,
    VPlaceholder,
    VButton,
    NosologyForm,
  },
  mixins: [mkbMixin],
  async mounted() {
    await this.fetchNosology();
    try {
      await this.getMkbDiagnoses();
    } catch (error) {
      console.error(error);

      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  },
  data() {
    return {
      nosology: null,
      isLoading: true,
      isError: false,
      isEditMode: false,
      nosologyTitle: null,
      backBtnActive: false,
    }
  },
  methods: {
    backBtnHandler() {
      if(this.isEditMode) {
        this.backBtnActive = true;
      } else {
        this.$router.push('/remote-monitoring/kzs/nosology');
      }
    },
    updateNosologyHandler(updatedNosology) {
      this.nosology = updatedNosology;
      this.nosologyTitle = this.nosology.name;
      this.isEditMode = false;
    },
    updateBackBtnActive(value) {
      this.backBtnActive = value;
    },
    cancelHandler() {
      this.isEditMode = false;
      this.backBtnActive = false;
    },
    async fetchNosology() {
      const id = this.$route.params.id;
      if (!id) {
        this.$router.push('/remote-monitoring/kzs/nosology');
        return;
      }
      try {
        const response = await nosologyService.getNosologyById(id);
        if (response) {
          this.nosology = response;
          this.nosologyTitle = this.nosology.name;
          this.isLoading = false;
        }
      } catch (error) {
        this.isError = true;
        console.error('Ошибка при получении нозологии:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },

}
</script>
